class ConfiguratorData {
    constructor () {

        this.cross = {};/*Картинка крестика*/
        this.info = {};/*Картинка i в кружке*/
        this.popupBg = {};/*Фон для попапа*/
        this.materialAlertBg = {};/*Фон для попапа когда нет рендера*/
        this.translatedPhrases = {};/*Перевод фраз из админки*/
        this.noModuleSofa = {};/*Модульный или немодульный диван*/
        this.customStartMaterial = {};/*Стартовый материал*/

        /*Интерьеры*/
        this.interiors = {
            1: {
                'src' : '/wp-content/themes/classy/assets/img/configurator-canvas/rooms/room-3.jpg',
                'type' : 'image'
            },
            2: {
                'src' : '/wp-content/themes/classy/assets/img/configurator-canvas/rooms/room-1.jpg',
                'type' : 'image'
            },
            3: {
                'src' : '/wp-content/themes/classy/assets/img/configurator-canvas/rooms/room-2.jpg',
                'type' : 'image'
            },
            4: {
                'src' : '/wp-content/themes/classy/assets/img/configurator-canvas/rooms/room-4.jpg',
                'type' : 'image'
            }
        };
    }
}

export default ConfiguratorData;